exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".typeahead{width:100%}.typeahead__input{width:100%;color:#e96661;border:1px solid #e96661;padding:.2em .5em;font-size:1em;font-family:Merriweather}.typeahead__items-wrapper{position:relative;z-index:100}.typeahead__items{position:absolute;width:100%;top:-2px}.typeahead__item{line-height:1.2em;cursor:pointer;font-size:.9em;padding:.5em;border:1px solid #e96661;border-top:none;background-color:#fff}.typeahead__item:first-child{border-top:1px solid #e96661}.typeahead__item:hover{background-color:#fce8e7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eb11219c","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/typeahead/typeahead.vue
// module id = 74
// module chunks = 0